import intersection from 'lodash/intersection'

const isAuthorised = (requiredRoles = [], roles = []) => {
    if (requiredRoles.length === 0) {
        return true
    }

    return intersection(requiredRoles, roles).length > 0
}

export default isAuthorised
